module.exports = __webpack_public_path__ + "static/media/link.17db2ef3.svg";